export class LoginInfoError extends Error {
  public readonly errorCode?: string;

  public readonly isUserCancelled: boolean;

  public readonly isTokenAcquisitionFailed: boolean;

  public readonly isLoginFailed: boolean;

  public readonly isPopupBlocked: boolean;

  constructor(
    message: string,
    errorCode?: string,
    public readonly originalError?: unknown,
  ) {
    super(message);
    this.name = 'LoginInfoError';
    this.errorCode = errorCode;

    // Check if popup was blocked by browser
    this.isPopupBlocked =
      errorCode === 'popup_window_error' ||
      errorCode === 'empty_window_error' ||
      errorCode === 'monitor_window_timeout' ||
      message.toLowerCase().includes('popup') ||
      message.toLowerCase().includes('blocked');

    // Check if user cancelled the popup
    this.isUserCancelled =
      errorCode === 'user_cancelled' ||
      errorCode === 'access_denied' ||
      message.toLowerCase().includes('cancel');

    // Check if token acquisition failed
    this.isTokenAcquisitionFailed =
      errorCode === 'token_acquisition_failed' ||
      message.toLowerCase().includes('token');

    // Check if login failed
    this.isLoginFailed =
      errorCode === 'login_failed' || message.toLowerCase().includes('login');
  }
}
